import axios from "axios";
import actions from "./actions";
import { getFilterUrlPart } from "../../lib/utils";
import _ from "lodash";

const fetchDomainScores = (id, options) => (dispatch, getState) => {
  dispatch(actions.fetchDomainScoresStart());
  const {
    actualSurvey,
    survey,
    units,
    token,
    comparativeDatasets,
    comparativeUnitMappings,
    comparativePositionMappings,
    appliedBenchmark
  } = options;
  if (survey.indexOf("Pulse") > -1) {
    return dispatch(
      actions.fetchDomainScores({
        hospital: null,
        unit: null,
        prevYear: null,
      })
    );
  }
  const urlParams = `version=${actualSurvey}&token=${token}`;
  const requestBody = { comparativeDatasets, comparativeUnitMappings, comparativePositionMappings };
  const unitsParam = units
    ? `&units='${_.map(units, function(unit) {
      return encodeURIComponent(unit); //unit.replace(/&/g, "%26");
    }).join(`','`)}'`
    : "";
  const filterParams = getFilterUrlPart(getState().filters);

  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch(err => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchDomainScoresError(err));
      }
    });
  }
  function getDomainScores(url) {
    return retryOnFail(function() {
      return axios.post(url, requestBody).then(res => {
        return res.data.scores;
      });
    });
  }

  const promises = [getDomainScores(`/api/survey/${id}/domainScores?${urlParams}&benchmarks=${appliedBenchmark}${filterParams}`)];
  if (units) {
    promises.push(
      getDomainScores(`/api/survey/${id}/domainScores?${urlParams}&benchmarks=${appliedBenchmark}${unitsParam}${filterParams}`)
    );
  } else {
    promises.push(Promise.resolve(undefined));
  }
  if (comparativeDatasets) {
    const prevDataset = _.reduce(
      _.map(comparativeDatasets.split("||"), function(dataset) {
        return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
      }),
      function(highest, next) {
        return (highest.year < next.year || highest.id === "this") && next.id !== "this" ? next : highest;
      }
    );
    promises.push(
      getDomainScores(
        `/api/survey/${prevDataset.id}/domainScores?${urlParams}&benchmarks=${appliedBenchmark}${unitsParam}${filterParams}`
      )
    );
  } else {
    promises.push(Promise.resolve(undefined));
  }
  Promise.all(promises).then(results => {
    dispatch(
      actions.fetchDomainScores({
        hospital: results[0],
        unit: results[1],
        prevYear: results[2],
      })
    );
  });
};

const clearProgress = () => (dispatch, getState) => {
  dispatch(actions.fetchDomainScoresStart());
};

export default {
  fetchDomainScores,
  clearProgress,
};



// WEBPACK FOOTER //
// ./src/redux/domainScores/operations.js